<template>
  <div class="search-box">
    <form action="/search">
      <van-search v-model="keyword" placeholder="输入关键字搜索" shape="round" v-bind="$attrs"
        @focus="isShow = true && list.length > 0" @input="handleInput" @search="onSearch" />
    </form>
    <div v-show="isShow" class="history-list">
      <van-tag v-for="item in list" :key="item" closeable color="#e5e5e5" plain size="large" style="margin: 8px"
        text-color="#333" @click="handleList(item)" @close="close(item)">
        {{ item }} &nbsp;
      </van-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: "search",

  data() {
    return {
      keyword: this.data || "",
      isShow: false,
      // searchVal:'',// JSON.parse(sessionStorage.getItem("searchVal") || "[]"),
      list: [],
    };
  },

  props: {
    data: {
      typeof: String,
      default: "",
    },
  },

  created() {
    this.list = JSON.parse(sessionStorage.getItem("searchVal") || "[]");
    document.body.addEventListener("click", this.handleBodyClick);
  },

  beforeDestroy() {
    document.body.removeEventListener("click", this.handleBodyClick);
  },

  methods: {
    close(tag) {
      budo_log.info("#48 close", tag)

      this.list.forEach((item, index) => {
        if (item === tag) {
          this.list.splice(index, 1);
          sessionStorage.setItem("searchVal", JSON.stringify(this.list));
        }
      })
    },

    handleBodyClick(event) {
      event.target.type !== "search" && (this.isShow = false);
    },

    handleInput(val) {
      budo_log.debug("#56 handleInput", val)
    },

    onSearch() {
      const searchVal = JSON.parse(sessionStorage.getItem("searchVal") || "[]");
      if (!searchVal.includes(this.keyword)) {
        searchVal.push(this.keyword);
      }

      sessionStorage.setItem("searchVal", JSON.stringify(searchVal));
      this.list = JSON.parse(sessionStorage.getItem("searchVal") || "[]");
      this.$emit("search", this.keyword);
    },

    handleList(val) {
      this.keyword = val + "";
      this.onSearch();
    },
  },
};
</script>

<style lang="scss">
.search-box {
  position: relative;

  .history-list {
    position: absolute;
    width: 100%;
    overflow-y: auto;
    z-index: 9999;
    background-color: #fff;
    padding: 8px;
  }
}
</style>
